export const isPushSupported = () => {
  return typeof window !== 'undefined'
    && 'serviceWorker' in navigator
    && 'Notification' in window;
};

export const getUserPushStorageKey = (user) => user?.user_id || user?.id || null;

export const getPushPromptStorageKey = (userStorageKey) => `postreams-push-prompt:${userStorageKey}`;

export const getPushTokenStorageKey = (userStorageKey) => `postreams-push-token:${userStorageKey}`;

export const isSuccessfulResponse = (response) => response?.success !== false;

export const getPushMessageContent = (payload) => {
  const title = payload?.notification?.title || payload?.data?.title || 'Postreams notification';
  const body = payload?.notification?.body || payload?.data?.message || payload?.data?.body || '';
  const link = payload?.data?.click_action || payload?.data?.url || '/dashboard';

  return {
    title,
    body,
    link,
  };
};
